export { VaProductDetailsV2Component } from './product-details-v2.component';
export { MarketingType, PersonaType, SelectedTab } from './product-details-v2.interface';
export { EditionSelectorComponent } from './edition-selector/edition-selector.component';
export { EditionSelectorService } from './edition-selector/edition-selector.service';
export { DialogData, DialogResponse, ResponseType } from './edition-selector/edition-selector.types';
